import { FaGithub, FaGlobeAmericas, FaServer } from "react-icons/fa";
import { HiOutlineExternalLink } from 'react-icons/hi';
import { BgPositionBottom, BgPositionTop } from "./projectsData";
import redOnion from "../../assets/images/projects/red-onion.jpg";


export const Project5 = () => {
    return (  
        
        <div className='h-auto md:p-0 '>
            <div className='h-[200px] sm:h-[300px] w-auto px-3 pt-3 '>
                <div className='h-full details-img cursor-grab rounded-t-[3px]' 
                    style={{background: `url(${redOnion})`, backgroundPosition: 'top', backgroundSize: 'cover'}} 
                    onMouseOut={BgPositionBottom} onMouseOver={BgPositionTop}>
                </div>
            </div>
            <div className='bg-white dark:bg-light-black rounded-b-[3px]'>
                <div className='px-3 pb-3 dark:text-light-blue'>
                    <a href='https://red-onion-restaurant-c4561.web.app' target="_blank" rel="noopener noreferrer">
                        <div className="inline-flex items-center text-indigo-500 text-[26px] font-medium my-3">
                            <h4>Red Onion</h4>&nbsp;
                            <HiOutlineExternalLink/>
                        </div>
                    </a>
                    <p>Red Onion is a restaurant website where you can order a variety of food. You can see the food you ordered in the cart and checkout the cart with your information.</p>
                    <div className='flex flex-wrap'>
                            <span className='bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2'>React JS</span>
                            <span className='bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2'>Tailwind Css</span>
                            <span className='bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2'>Firebase</span>
                            <span className='bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2'>Stripe</span>
                            <span className='bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2'>React Router v6</span>
                            <span className='bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2'>React Hook Form</span>
                            <span className='bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2'>Sweet Alert</span>
                            <span className='bg-light-blue dark:bg-gray-600 p-2 rounded mr-2 mt-2'>React Icons</span>
                    </div>
                    <div className='flex text-2xl mt-4 justify-between flex-wrap'>
                        <a href='https://red-onion-restaurant-c4561.web.app' className='hover:text-indigo-500 transform translate duration-500 mr-3 dark:text-white dark:hover:text-indigo-500'  target="_blank" rel="noopener noreferrer">
                            <div className="flex justify-center items-center">
                                <FaGlobeAmericas className="text-indigo-500" title='Live Preview'/>&nbsp;
                                <span className="text-lg underline underline-offset-4 decoration-indigo-500">Live Preview</span>
                            </div>
                        </a>
                        <a href='https://github.com/mohammadliazul/red-onion-restaurant' className='hover:text-indigo-500 transform translate duration-500 mr-3 dark:text-white dark:hover:text-indigo-500'  target="_blank" rel="noopener noreferrer">
                            <div className="flex justify-center items-center">
                                <FaGithub className="text-indigo-500" title='Front-End Code'/>&nbsp;
                                <span className="text-lg underline underline-offset-4 decoration-indigo-500">Front-End Code</span>
                            </div>
                        </a>
                        <div className='hover:text-indigo-500 transform translate duration-500 mr-3 dark:text-white dark:hover:text-indigo-500 cursor-not-allowed'>
                            <div className="flex justify-center items-center">
                                <FaServer className="text-indigo-500" title='Back-End Code'/>&nbsp;
                                <span className="text-lg underline underline-offset-4 decoration-indigo-500">Back-End Code</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )};